export default __webpack_public_path__ + "static/media/historic-performace-gsec-fof.edbc0dfb.png";